import { baseResources, baseResourceActions } from "routes/enum";

const { KB_FORM_SETTING, KB_FORM_CONTENT, KB_FORM_ITEM } = baseResources;
const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

export const FORM_READ_PERMISSION = [`${READ}_${KB_FORM_SETTING}`];
export const FORM_UPDATE_PERMISSION = [`${UPDATE}_${KB_FORM_SETTING}`];
export const FORM_DELETE_PERMISSION = [`${DELETE}_${KB_FORM_SETTING}`];
export const FORM_CONTENT_UPDATE_PERMISSION = [`${UPDATE}_${KB_FORM_CONTENT}`];
export const FORM_ITEM_CREATE_PERMISSION = [`${CREATE}_${KB_FORM_ITEM}`];

export const FORM_SAVE_PERMISSION = [
    ...FORM_UPDATE_PERMISSION,
    ...FORM_CONTENT_UPDATE_PERMISSION,
];

export const FORM_ITEM_WRITE_PERMISSION = [
    ...FORM_ITEM_CREATE_PERMISSION,
    ...FORM_CONTENT_UPDATE_PERMISSION,
];
